import PropTypes from 'prop-types';
import React from 'react';
import { Grid } from 'react-bootstrap';
import { Redirect } from 'react-router';
import { Route, Switch } from 'react-router-dom';
import ConnectedLogin from '../Login/Login';
import ConnectedLogout from '../Login/Logout/Logout';
import './App.css';

const App = ({ location }) => (
  <Grid fluid >
    <Switch>
      <Route exact path="/" component={ConnectedLogin} />
      <Route exact path="/login" component={ConnectedLogin} />
      <Route exact path="/logout" component={ConnectedLogout} />

      <Redirect to={`/login?back=${location.pathname}`} />
    </Switch>
  </Grid>);

App.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default App;



// WEBPACK FOOTER //
// ./src/components/App/App.jsx